import { useTranslation } from 'react-i18next'

import { Namespace } from '~/i18n'
import {
  Button,
  ButtonVariant,
  CallToActionSection,
  Icon,
  IconName,
  TextS,
} from '~/tenset-components'

export function CallToActionContactSection() {
  const { t } = useTranslation([Namespace.CONTACT_PAGE])

  return (
    <CallToActionSection
      title={t('callToAction.title')}
      description={t('callToAction.description')}
    >
      <div>
        <Button
          variant={ButtonVariant.Secondary}
          className="w-full md:w-auto"
          to="https://t.me/the_tenset"
        >
          <Icon name={IconName.Telegram} />
          <TextS> {t('callToAction.action')} </TextS>
        </Button>
      </div>
    </CallToActionSection>
  )
}
